/* reporté de theme.liquid code custom inline 2026-09-17 */
/* (16 oct. 2026) Ancien script de synchronisation du formulaire ShipAid retiré : ShipAid est en pause et son widget n'est plus affiché. */

document.addEventListener('DOMContentLoaded', function () {
  function isEnglishPage() {
    return window.location.pathname.startsWith('/en/');
  }

  if (!isEnglishPage()) return;

  const translations = {
    "Quels termes décrivent le produit que vous avez acheté ? Vous pouvez en choisir plus d'un.": "Which terms describe the product you purchased? You can choose more than one.",
    "Sélectionnez autant que vous le souhaitez": "Select as many as you like",

    "Belle qualité": "Great quality",
    "Fidèle à la description": "Accurate description",
    "Bon rapport qualité-prix": "Good value for money",
    "Livraison rapide": "Fast delivery",
    "Bien emballé": "Well packaged",
    "Je recommande": "I recommend it"
  };

  function replaceJudgeMeText() {
    document.querySelectorAll('body *').forEach(function (el) {
      if (el.children.length > 0) return;

      const text = el.textContent.trim();

      if (translations[text]) {
        el.textContent = translations[text];
      }
    });
  }

  replaceJudgeMeText();

  const observer = new MutationObserver(function () {
    replaceJudgeMeText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
(function () {
  const synonyms = {
  'chandelle': ['chandelle', 'bougie'],
  'bougie': ['bougie', 'chandelle'],

  'amour': ['amour', 'love', 'cayer'],
  'love': ['amour', 'love', 'cayer'],
  'cayer': ['amour', 'love', 'cayer'],

  'affiche': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'affiches': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'poster': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'posters': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'print': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],
  'prints': ['affiche', 'affiches', 'poster', 'posters', 'print', 'prints'],

  'agenda': ['agenda', 'agendas', 'planner', 'planners'],
  'agendas': ['agenda', 'agendas', 'planner', 'planners'],
  'planner': ['agenda', 'agendas', 'planner', 'planners'],
  'planners': ['agenda', 'agendas', 'planner', 'planners']
};

  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!form.matches('form[action*="/search"]')) return;

    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const originalQuery = input.value.trim();
    const query = originalQuery.toLowerCase();

    if (!synonyms[query]) {
      sessionStorage.removeItem('slSynonymSearch');
      return;
    }

    event.preventDefault();

    const expandedQuery =
      '(' + synonyms[query].join(' OR ') + ')';

    sessionStorage.setItem(
      'slSynonymSearch',
      JSON.stringify({
        original: originalQuery,
        expanded: expandedQuery
      })
    );

    /* On construit la recherche sans modifier le champ visible */
    const params = new URLSearchParams(new FormData(form));
    params.set('q', expandedQuery);

    const url = new URL(form.action, window.location.origin);

    params.forEach(function(value, key) {
      url.searchParams.set(key, value);
    });

    window.location.assign(url.toString());
  });

  (function restoreSynonymDisplay() {
    const saved = sessionStorage.getItem('slSynonymSearch');

    if (!saved) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    let searchData;

    try {
      searchData = JSON.parse(saved);
    } catch (e) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const actualQuery = params.get('q') || '';

    if (actualQuery !== searchData.expanded) {
      document.documentElement.classList.remove('sl-synonym-search-loading');
      return;
    }

    const originalQuery = searchData.original;

    /* Affiche seulement le terme réellement tapé */
    document.querySelectorAll(
      'form[action*="/search"] input[name="q"]'
    ).forEach(function(input) {
      input.value = originalQuery;
    });

    /* Corrige le gros titre */
    const heading = document.querySelector(
      '.shopify-section--main-search h1.h2.text-center'
    );

    /*if (heading) {
      const count = {{ search.results_count | default: 0 | json }};

      if (document.documentElement.lang.toLowerCase().startsWith('en')) {
        heading.textContent =
          count + ' result' + (count === 1 ? '' : 's') +
          ' for "' + originalQuery + '"';
      } else {
        heading.textContent =
          count + ' résultat' + (count === 1 ? '' : 's') +
          ' pour "' + originalQuery + '"';
      }
    }*/

    /* Tout est corrigé : on affiche la zone */
    document.documentElement.classList.remove('sl-synonym-search-loading');
})();
})();

/* reporté de header.liquid code custom inline 2026-09-17
   Réactivé le 16 oct. 2026 : {{ section.id }} n'est pas interprété dans un fichier .js ; on retrouve la section
   de l'en-tête à partir de la barre de recherche elle-même (.mobile-sticky-search, sections/header.liquid). */
(function () {
    function initMobileSearchStickiness() {
      const barre = document.querySelector('.mobile-sticky-search');
      const section = barre ? barre.closest('.shopify-section') : null;
      if (!section) return;

      const searchBar = section.querySelector('.mobile-sticky-search');
      if (!searchBar) return;
      const desktopSearch = section.querySelector(
        'store-header .header__icon-list a[aria-controls="search-drawer"]'
      );

      let placeholder = section.querySelector('.mobile-sticky-search-placeholder');

      if (!placeholder) {
        placeholder = document.createElement('div');
        placeholder.className = 'mobile-sticky-search-placeholder';
        searchBar.parentNode.insertBefore(placeholder, searchBar);
      }

      let triggerY = 0;
      let ticking = false;

      function reset() {
        searchBar.classList.remove('is-fixed');
        placeholder.classList.remove('is-active');
        placeholder.style.height = '0px';
      }

      function measure() {
  reset();

  if (window.innerWidth >= 700) {
  if (desktopSearch) {
    const desktopSearchRect = desktopSearch.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const rightOffset = Math.max(
  0,
  viewportWidth - desktopSearchRect.right - 36
  );

    searchBar.style.setProperty(
      '--desktop-search-right',
      rightOffset + 'px'
    );
  }

  triggerY =
    section.getBoundingClientRect().bottom +
    window.scrollY;

  placeholder.style.height = '0px';
  } else {
    triggerY =
      searchBar.getBoundingClientRect().top +
      window.scrollY;

    placeholder.style.height =
      searchBar.offsetHeight + 'px';
  }

  update();
}

      function update() {
        

        if (window.scrollY > triggerY) {
          searchBar.classList.add('is-fixed');
          placeholder.classList.add('is-active');
        } else {
          searchBar.classList.remove('is-fixed');
          placeholder.classList.remove('is-active');
        }
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            update();
            ticking = false;
          });

          ticking = true;
        }
      }, { passive: true });

      window.addEventListener('resize', measure);

      measure();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileSearchStickiness);
    } else {
      initMobileSearchStickiness();
    }
  })();

/* ==========================================================================
   Rattrapage du 16 oct. 2026 : fonctions reprises du thème en ligne
   ========================================================================== */

/* En-tête compact sur ordinateur (1150 px et plus) : l'en-tête reste fixé en haut au défilement, puis se compacte
   (le menu principal se replie) après 60 px. Styles : sl-theme.css, 3.9. Repris du bloc Liquid personnalisé
   custom_liquid_N47x8X de l'en-tête du thème en ligne. */
(function () {
  function init() {
    var tete = document.querySelector('store-header');
    if (!tete || tete.dataset.slFixe) return;
    tete.dataset.slFixe = '1';
    var boite = tete.parentElement;
    var fixe = false;
    var compact = false;
    var attente = false;
    function maj() {
      attente = false;
      var large = window.innerWidth >= 1150;
      var haut = boite.getBoundingClientRect().top;
      var veutFixe = large && haut < 0;
      var veutCompact = veutFixe && haut < -60;
      if (veutFixe && !fixe) {
        boite.style.minHeight = boite.offsetHeight + 'px';
        tete.classList.add('sl-fixe');
        fixe = true;
      }
      if (veutCompact !== compact) {
        compact = veutCompact;
        tete.classList.toggle('sl-compact', compact);
        if (compact) {
          tete.querySelectorAll('.header__main-nav details[open]').forEach(function (d) { d.removeAttribute('open'); });
        }
      }
      if (!veutFixe && fixe) {
        tete.classList.remove('sl-fixe');
        boite.style.minHeight = '';
        fixe = false;
      }
    }
    function demande() {
      if (!attente) { attente = true; window.requestAnimationFrame(maj); }
    }
    window.addEventListener('scroll', demande, { passive: true });
    window.addEventListener('resize', demande);
    maj();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Fiche produit, carte « Service client disponible » : le lien ouvre la bulle Shopify Inbox
   (bouton caché dans le shadow DOM de l'app). Lien marqué data-sl-ouvrir-clavardage dans
   snippets/sl-product-reassurance-card.liquid. */
(function () {
  function chercher(selecteur, racine) {
    racine = racine || document;
    var direct = racine.querySelector(selecteur);
    if (direct) return direct;
    var tous = racine.querySelectorAll('*');
    for (var i = 0; i < tous.length; i++) {
      if (tous[i].shadowRoot) {
        var trouve = chercher(selecteur, tous[i].shadowRoot);
        if (trouve) return trouve;
      }
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var lien = e.target.closest('[data-sl-ouvrir-clavardage]');
    if (!lien) return;
    e.preventDefault();
    var bouton = chercher('button[data-spec="toggle-button"]');
    if (!bouton) return;
    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      bouton.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
    });
  });
})();

/* Page panier : la case « commande cadeau » affiche ou cache le champ du message (déplacé de sections/main-cart.liquid).
   La case n'existe pas quand le panier est vide. */
(function () {
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.id !== 'gift_order_yes') return;
    var champ = document.getElementById('gift_order_note_container');
    if (!champ) return;
    champ.style.opacity = e.target.checked ? '1' : '0';
    champ.style.height = e.target.checked ? '130px' : '0';
  });
})();

/* Page « Créez votre boîte-cadeau personnalisée » (sections/sl-boite-cadeau.liquid) :
   - bouton « Étape suivante » : ouvre l'onglet suivant et le ramène à l'écran ;
   - « Sauvegarder le message » : enregistre le message dans les attributs du panier sans quitter la page
     (l'ancienne version utilisait jQuery, retiré du thème). « Sauvegarder et passer la commande » reste un envoi normal. */
(function () {
  document.addEventListener('click', function (e) {
    var suivant = e.target.closest('[data-sl-etape-suivante]');
    if (suivant) {
      var onglets = suivant.closest('x-tabs');
      if (!onglets) return;
      var boutons = Array.prototype.slice.call(onglets.querySelectorAll('button[slot="title"]'));
      var panneaux = Array.prototype.slice.call(onglets.querySelectorAll('[role="tabpanel"]'));
      var k = panneaux.indexOf(suivant.closest('[role="tabpanel"]'));
      if (k >= 0 && boutons[k + 1]) {
        boutons[k + 1].click();
        boutons[k + 1].scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      return;
    }
    var sauver = e.target.closest('[data-sl-message-cadeau] [name="save_message"]');
    if (sauver) {
      e.preventDefault();
      var form = sauver.closest('form');
      var etat = form.querySelector('[data-sl-message-etat]');
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (r) {
        if (etat && r.ok) { etat.hidden = false; }
      }).catch(function () {});
    }
  });
})();

/* Panier, barre de livraison gratuite à 2 paliers (snippets/free-shipping-bar-2-milestones.liquid), repris du thème
   en ligne (15 oct. 2026). Le script d'Impact (FreeShippingBar._updateMessage) cherche un message à un seul palier
   qui n'existe pas dans cette barre : il plantait à chaque changement du panier (« Cannot read properties of null »).
   1) Le script d'Impact ne touche plus au message de cette barre (la progression continue d'avancer normalement) ;
   2) à chaque changement du panier, on reprend la barre recalculée par Shopify (jointe à la réponse du panier,
      sinon demandée au serveur) et on remplace le message et les paliers atteints. */
(function () {
  if (!window.customElements) return;
  customElements.whenDefined('free-shipping-bar').then(function () {
    var C = customElements.get('free-shipping-bar');
    var original = C && C.prototype._updateMessage;
    if (!original) return;
    C.prototype._updateMessage = function () {
      if (this.querySelector('.free-shipping-bar__message')) return;
      return original.apply(this, arguments);
    };
  });
  function majBarres(html) {
    var neuve = html && new DOMParser().parseFromString(html, 'text/html').querySelector('free-shipping-bar');
    if (!neuve) return false;
    Array.prototype.forEach.call(document.querySelectorAll('free-shipping-bar'), function (b) {
      ['.free-shipping-bar__message', '.progress-bar__milestones'].forEach(function (sel) {
        var actuel = b.querySelector(sel), nouveau = neuve.querySelector(sel);
        if (actuel && nouveau) actuel.innerHTML = nouveau.innerHTML;
      });
      ['data-total-price', 'data-progress'].forEach(function (att) {
        if (neuve.hasAttribute(att)) b.setAttribute(att, neuve.getAttribute(att));
      });
    });
    return true;
  }
  document.addEventListener('cart:change', function (e) {
    if (!document.querySelector('free-shipping-bar .free-shipping-bar__message')) return;
    var s = e.detail && e.detail.cart && e.detail.cart.sections, html = null;
    if (s) for (var k in s) { if (s[k] && s[k].indexOf('<free-shipping-bar') > -1) { html = s[k]; break; } }
    if (majBarres(html)) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { majBarres(j['cart-drawer']); })
      .catch(function () {});
  });
})();

/* Recommandations du tiroir du panier : composant <cart-recommendations> (snippets/sl-tiroir-recommandations.liquid).
   Repris du thème en ligne, où il avait été ajouté dans assets/theme.js d'Impact. Pour chacun des 3 premiers produits
   du panier, on demande la section cart-drawer-recommendations-source dans le contexte de ce produit, puis on répartit
   les places (data-limit, 6) entre eux, sans doublon ni produit déjà au panier. */
(function () {
  if (!window.customElements || window.customElements.get('cart-recommendations')) return;
  var CartRecommendations = class extends HTMLElement {
    connectedCallback() {
      this._abortController = new AbortController();
      this._loadRecommendations();
    }
  
    disconnectedCallback() {
      this._abortController?.abort();
    }
  
    async _loadRecommendations() {
      const layoutTemplate = this.querySelector(
        "template[data-recommendations-layout]"
      );
  
      const sectionId = this.dataset.sectionId;
  
      const limit = Math.max(
        1,
        parseInt(this.dataset.limit || "4", 10)
      );
  
      if (!layoutTemplate || !sectionId) {
        return;
      }
  
      let productIds = [];
      let productHandles = [];
  
      try {
        productIds = JSON.parse(
          this.dataset.productIds || "[]"
        );
      } catch (error) {
        console.error(
          "Unable to read cart product IDs:",
          error
        );
      }
  
      try {
        productHandles = JSON.parse(
          this.dataset.productHandles || "[]"
        );
      } catch (error) {
        console.error(
          "Unable to read cart product handles:",
          error
        );
      }
  
      productIds = [
        ...new Set(
          productIds
            .map(String)
            .filter(Boolean)
        )
      ];
  
      /*
       * On analyse au maximum les trois premiers
       * produits distincts du panier.
       */
      productHandles = [
        ...new Set(
          productHandles
            .map(String)
            .filter(Boolean)
        )
      ].slice(0, 3);
  
      if (productHandles.length === 0) {
        return;
      }
  
      const seenProductIds = new Set(productIds);
      const recommendationTemplates = [];
  
      try {
        /*
         * Charge la section dans le contexte de chaque
         * page produit afin que Liquid utilise le bon produit.
         */
        const responseResults =
          await Promise.allSettled(
            productHandles.map(
              async (productHandle) => {
                const productPath =
                  `${Shopify.routes.root}products/` +
                  `${encodeURIComponent(productHandle)}`;
  
                const url =
                  `${productPath}?section_id=` +
                  `${encodeURIComponent(sectionId)}`;
  
                const response = await fetch(url, {
                  signal: this._abortController.signal
                });
  
                return response.ok
                  ? response.text()
                  : "";
              }
            )
          );
  
        if (this._abortController.signal.aborted) {
          return;
        }
  
        const parser = new DOMParser();
  
        const recommendationGroups =
          responseResults.map((result) => {
            if (
              result.status !== "fulfilled" ||
              !result.value
            ) {
              return [];
            }
  
            const documentFromResponse =
              parser.parseFromString(
                result.value,
                "text/html"
              );
  
            return Array.from(
              documentFromResponse.querySelectorAll(
                "template[data-similar-product-id]"
              )
            );
          });
  
        const groupIndexes =
          recommendationGroups.map(() => 0);
  
        const groupAddedCounts =
          recommendationGroups.map(() => 0);
  
        const maxPerSource =
          recommendationGroups.length > 1
            ? Math.ceil(
                limit / recommendationGroups.length
              )
            : limit;
  
        const addNextFromGroup = (groupIndex) => {
          const group =
            recommendationGroups[groupIndex];
  
          while (
            groupIndexes[groupIndex] < group.length
          ) {
            const template =
              group[groupIndexes[groupIndex]];
  
            groupIndexes[groupIndex] += 1;
  
            const recommendedProductId =
              template.dataset.similarProductId;
  
            if (
              !recommendedProductId ||
              seenProductIds.has(recommendedProductId)
            ) {
              continue;
            }
  
            seenProductIds.add(recommendedProductId);
            recommendationTemplates.push(template);
            groupAddedCounts[groupIndex] += 1;
  
            return true;
          }
  
          return false;
        };
  
        let addedInRound = true;
  
        /*
         * Première passe équilibrée :
         * chaque produit du panier reçoit sa part.
         */
        while (
          recommendationTemplates.length < limit &&
          addedInRound
        ) {
          addedInRound = false;
  
          for (
            let groupIndex = 0;
            groupIndex < recommendationGroups.length;
            groupIndex += 1
          ) {
            if (
              groupAddedCounts[groupIndex] >=
              maxPerSource
            ) {
              continue;
            }
  
            if (addNextFromGroup(groupIndex)) {
              addedInRound = true;
            }
  
            if (
              recommendationTemplates.length >= limit
            ) {
              break;
            }
          }
        }
  
        /*
         * Deuxième passe :
         * complète les places restantes lorsqu'un groupe
         * ne possède pas assez de produits similaires.
         */
        addedInRound = true;
  
        while (
          recommendationTemplates.length < limit &&
          addedInRound
        ) {
          addedInRound = false;
  
          for (
            let groupIndex = 0;
            groupIndex < recommendationGroups.length;
            groupIndex += 1
          ) {
            if (addNextFromGroup(groupIndex)) {
              addedInRound = true;
            }
  
            if (
              recommendationTemplates.length >= limit
            ) {
              break;
            }
          }
        }
      } catch (error) {
        if (error.name === "AbortError") {
          return;
        }
  
        console.error(
          "Unable to load similar cart products:",
          error
        );
      }
  
      if (recommendationTemplates.length === 0) {
        return;
      }
  
      const layout = document.importNode(
        layoutTemplate.content,
        true
      );
  
      const listElement = layout.querySelector(
        "[data-recommendations-list]"
      );
  
      if (!listElement) {
        return;
      }
  
      recommendationTemplates.forEach((template) => {
        listElement.append(
          document.importNode(
            template.content,
            true
          )
        );
      });
  
      if (recommendationTemplates.length <= 1) {
        layout
          .querySelector(
            "[data-recommendation-controls]"
          )
          ?.remove();
      }
  
      this.replaceChildren(layout);
      this.hidden = false;
    }
  };
  window.customElements.define('cart-recommendations', CartRecommendations);
})();

/* Blogue Le Répertoire (sections/main-blog-repertoire.liquid) : au chargement, la rangée de filtres défile jusqu'au
   filtre actif. Réécrit sans jQuery le 16 oct. 2026 (l'ancien script plantait : « jQuery is not defined »). */
window.addEventListener('load', function () {
  document.querySelectorAll('.blog-banner .scroll-area').forEach(function (zone) {
    var actif = zone.querySelector('li[aria-selected="true"]');
    if (!actif) return;
    var decalage = actif.getBoundingClientRect().left - zone.getBoundingClientRect().left + zone.scrollLeft;
    if (decalage > zone.scrollLeft) {
      zone.scrollTo({ left: decalage, behavior: 'smooth' });
    }
  });
});

/* ==========================================================================
   Fiche produit (repris du thème en ligne le 16 oct. 2026, où ce code était écrit dans sections/main-product.liquid)
   ========================================================================== */

/* Barre d'ajout rapide (sections/main-product.liquid) : le sous-total suit la quantité choisie.
   Le prix unitaire vient de data-sl-prix-unitaire, que product-rerender d'Impact remet à jour à chaque changement
   de variante. Le texte n'est réécrit que s'il change (l'ancienne version réécrivait sans arrêt et tournait en boucle). */
(function () {
  function sousTotal() {
    var el = document.querySelector('.product-quick-add__subtotal[data-sl-prix-unitaire]');
    if (!el) return;
    var barre = el.closest('product-quick-add');
    var formId = barre ? barre.getAttribute('form') : null;
    var qte = 1;
    if (formId) {
      var champ = document.querySelector('input[name="quantity"][form="' + formId + '"], #' + formId + ' input[name="quantity"]');
      var n = champ ? parseInt(champ.value, 10) : 1;
      if (n > 0) qte = n;
    }
    var prix = Number(el.getAttribute('data-sl-prix-unitaire')) || 0;
    var langue = (document.documentElement.lang || 'fr').toLowerCase().indexOf('en') === 0 ? 'en-CA' : 'fr-CA';
    var texte = new Intl.NumberFormat(langue, { style: 'currency', currency: 'CAD' }).format(prix * qte / 100);
    if (el.textContent !== texte) el.textContent = texte;
  }
  function plusTard() { requestAnimationFrame(function () { requestAnimationFrame(sousTotal); }); }
  document.addEventListener('change', function (e) { if (e.target.closest('quantity-selector, input[name="quantity"], variant-picker, form')) plusTard(); });
  document.addEventListener('input', function (e) { if (e.target.matches('input[name="quantity"]')) plusTard(); });
  document.addEventListener('click', function (e) { if (e.target.closest('quantity-selector button')) plusTard(); });
  document.addEventListener('variant:change', plusTard);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sousTotal); } else { sousTotal(); }
})();

/* Zoom des photos (ordinateur, 1000 px et plus) : un clic sur la photo l'agrandit 2 fois et elle suit la souris,
   un 2e clic (ou un clic ailleurs) la remet normale. Flèches précédente et suivante sur la photo.
   Balisage : .product-gallery__hover-zoom-container--active dans snippets/product-gallery.liquid ; styles : sl-theme.css, 5.6. */
(function () {
  function preparer(container) {
    if (container.dataset.zoomBound) return;
    var img = container.querySelector('img');
    if (!img) return;
    container.dataset.zoomBound = 'true';
    var mediaCarousel = container.closest('product-gallery') ? container.closest('product-gallery').querySelector('media-carousel') : null;
    var plusieurs = mediaCarousel && mediaCarousel.items && mediaCarousel.items.length > 1;
    var prevBtn = null, nextBtn = null;
    function visibilite() {
      if (!mediaCarousel || !plusieurs) return;
      var items = mediaCarousel.visibleItems || mediaCarousel.items || [];
      var k = items.indexOf(mediaCarousel.selectedSlide);
      if (prevBtn) prevBtn.style.display = k > 0 ? 'flex' : 'none';
      if (nextBtn) nextBtn.style.display = k < items.length - 1 ? 'flex' : 'none';
    }
    function fleche(sens) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product-gallery__hover-zoom-nav product-gallery__hover-zoom-nav--' + (sens < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', sens < 0 ? 'Previous image' : 'Next image');
      b.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="' + (sens < 0 ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        if (sens < 0) mediaCarousel.previous(); else mediaCarousel.next();
        setTimeout(visibilite, 100);
      }, true);
      container.appendChild(b);
      return b;
    }
    if (mediaCarousel && plusieurs) {
      prevBtn = fleche(-1); nextBtn = fleche(1);
      mediaCarousel.addEventListener('carousel:settle', visibilite);
      visibilite();
    }
    function suivre(e) {
      if (!container.classList.contains('is-click-zoomed') || e.target.closest('.product-gallery__hover-zoom-nav')) return;
      e.preventDefault(); e.stopPropagation();
      var r = container.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
      var y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      img.style.transform = 'scale(2) translate(' + ((0.5 - x) * r.width / 2) + 'px, ' + ((0.5 - y) * r.height / 2) + 'px)';
    }
    function fermer() {
      container.classList.remove('is-click-zoomed');
      container.removeEventListener('mousemove', suivre);
      img.style.transform = 'scale(1) translate(0, 0)';
    }
    function clic(e) {
      if (window.innerWidth < 1000 || e.target.closest('.product-gallery__hover-zoom-nav')) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (container.classList.contains('is-click-zoomed')) { fermer(); }
      else { container.classList.add('is-click-zoomed'); container.addEventListener('mousemove', suivre, { passive: false }); suivre(e); }
    }
    container.addEventListener('click', clic, true);
    document.addEventListener('click', function (e) {
      if (container.classList.contains('is-click-zoomed') && !container.contains(e.target)) fermer();
    }, true);
  }
  function tout() { document.querySelectorAll('.product-gallery__hover-zoom-container--active').forEach(preparer); }
  function demarrer() {
    tout();
    var galerie = document.querySelector('product-gallery');
    if (galerie) new MutationObserver(function () { setTimeout(tout, 100); }).observe(galerie, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); } else { demarrer(); }
})();

/* Galerie sur cellulaire (moins de 1000 px) : un glissement vertical sur la photo fait défiler la page au lieu
   d'être capté par le carrousel. */
(function () {
  if (!window.matchMedia('(max-width: 999px)').matches) return;
  function preparer() {
    var c = document.querySelector('media-carousel.product-gallery__media-list');
    if (!c || c.dataset.slVertical) return;
    c.dataset.slVertical = '1';
    var x0 = 0, y0 = 0, sens = null;
    c.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; sens = null; }
    }, { passive: true, capture: true });
    c.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1 || (!x0 && !y0)) return;
      var dx = Math.abs(e.touches[0].clientX - x0), dy = Math.abs(e.touches[0].clientY - y0);
      if (sens === null) {
        if (dy > dx && dy > 10) sens = 'vertical';
        else if (dx > dy && dx > 10) sens = 'horizontal';
      }
      if (sens === 'vertical') e.stopPropagation();
    }, { passive: false, capture: true });
    c.addEventListener('touchend', function () { x0 = 0; y0 = 0; sens = null; }, { passive: true, capture: true });
  }
  function demarrer() {
    preparer();
    var galerie = document.querySelector('product-gallery');
    if (galerie) new MutationObserver(function () { setTimeout(preparer, 100); }).observe(galerie, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', demarrer); } else { demarrer(); }
})();